import { SET_PAGE_METADATA } from '../actions/set-page-metadata';
import Wix from '../services/wix-sdk-polyfill';
import { getCurrentLocationPathname } from '../selectors/location-history-selectors';
import { setSiteInfo, SET_SITE_INFO } from '../actions/set-site-info';
import { debug } from '../services/debug';

// should not set metadata for root on load, only after metadata was set in another page
const INITIAL_PATH = '/';

const updatePageMetadata = ({ dispatch, metadata }) => {
  try {
    Wix.setPageMetadata(metadata);
    Wix.getSiteInfo(data => dispatch(setSiteInfo(data)));
  } catch (e) {
    debug.error(e);
  }
};

const setPageMetadataMiddleware = store => {
  let metadataSetOnPath = INITIAL_PATH;
  let initialDesciption;
  let currentPath;

  return next => action => {
    next(action);

    switch (action.type) {
      case SET_SITE_INFO:
        initialDesciption = initialDesciption || action.payload.siteDescription;
        break;
      case SET_PAGE_METADATA:
        currentPath = getCurrentLocationPathname(store.getState());
        if (metadataSetOnPath === currentPath) {
          break;
        }
        metadataSetOnPath = currentPath;
        updatePageMetadata({
          dispatch: store.dispatch,
          metadata: {
            // Should not set initial title as it will repeat it twice - SDK bug
            fullTitle: action.payload.title,
            description: action.payload.description || initialDesciption,
          },
        });
        break;
      default:
        break;
    }
  };
};

export default setPageMetadataMiddleware;
